import { CalendarItemType } from '$tablet-app/src/app/models';
import { calendarItemColors } from '$tablet-app/src/app/theme';
import {
  CalendarItemUnion,
  getCalendarItemBackgroundColor,
} from '@akin-home/calendar/combined';
import React, { FC } from 'react';
import { useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';
import EventScheduleItemContent from './EventScheduleItemContent';
import GoalReminderScheduleItemContent from './GoalReminderSheduleItemContent';
import MealScheduleItemContent from './MealScheduleItemContent';
import { ItemStyling } from './types';

interface Props {
  item: CalendarItemUnion;

  onPress?: (item: CalendarItemUnion) => void;
}

/** Item to be displayed in the breakdown schedule */
const BreakDownScheduleItem: FC<Props> = (props) => {
  const { item, onPress } = props;

  const handlePress = () => onPress?.(item);

  const { width } = useWindowDimensions();
  const isSmall = width < 500;

  const styling = isSmall ? smallStyling : largeStyling;

  let content = null;

  if (item.type === CalendarItemType.Meal) {
    content = <MealScheduleItemContent item={item} styling={styling} />;
  } else if (item.type === CalendarItemType.Alert && item.goalID) {
    content = (
      <GoalReminderScheduleItemContent
        item={item}
        goal_id={item.goalID}
        styling={styling}
      />
    );
  } else {
    content = <EventScheduleItemContent item={item} styling={styling} />;
  }

  return (
    <Container
      onPress={handlePress}
      event_type={item.type}
      style={{ backgroundColor: getCalendarItemBackgroundColor(item) }}
    >
      {content}
    </Container>
  );
};

const Container = styled.TouchableOpacity<{ event_type?: CalendarItemType }>`
  flex-direction: row;
  border-radius: 15px;
  padding: 16px;
  overflow: hidden;

  ${({ event_type }) => {
    if (!event_type) return '';
    return `background-color: ${calendarItemColors[event_type]};`;
  }}
`;

const smallStyling: ItemStyling = {
  titleTextVariant: 'p',
  subtitleTextVariant: 'p',
  emojiSize: 50,
  contentContainerStyle: {
    flexDirection: 'column',
  },
  imageContainerStyle: {
    height: '100%',
  },
  titleTextStyle: {
    fontSize: 18,
  },
};

const largeStyling: ItemStyling = {
  titleTextVariant: 'h3',
  subtitleTextVariant: 'p',
  emojiSize: 66,
  contentContainerStyle: {
    flexDirection: 'row',
  },
};

export default BreakDownScheduleItem;
